import { useEffect, useState } from "react";

import { useForm } from "../useForm";

import {
  generateUniqueNumber,
  wipStatusOptions,
  yesOrNoOptions,
  isReadOnlyUser,
} from "../../../shared/utility";
import ReceivingInvoiceFields from "./ReceivingInvoiceFields";
import ReceivingItemsTableComponent from "./ReceivingItemsTableComponent";
import DeleteConfirmationForm from "../DeleteConfirmationForm";
import { SnackbarData, SnackbarType } from "../../Snackbar";
import { useNavigate } from "react-router-dom";
import ButtonDropdown from "../../controls/ButtonDropdown";

const initialFValues = {
  // invoice_selected: null,
  invoice_number: "",
  id: null,
  truck_selected: null,
  created_by: null,
  supplier_selected: null,
  statusSelected: null,
  truck_question_1: null,
  truck_question_2: null,
  truck_question_3: null,
  truck_question_4: null,
  items: [],
};

export default function AddReceivingInvoiceForm(props) {
  const {
    askDeleteReceivingItemById,
    isEdit,
    truckOptions,
    fetchPosForTruck,
    productOptions,
    carrierOptions,
    supplierOptions,
    onFetchProductDetails,
    poOptions,
    setEmptyModelOpen,
    receiving,
    createReceivingInvoice,
    addItemToReceiving,
    updateReceivingItem,
    openDeleteItemByBarcodePopup,
    updateReceivingInvoice,
    employeeOptions,
    getWarehouses,
    getWarehouseLocations,
    isNewFlow,
    onDeleteReceivingInvoice,
    addSnackbar,
    askReturnSelectedItems,
    selectedItems,
    setSelectedItems,
    onUpdateUnitCostForReceivingItem,
    onUpdateTotalCostForReceivingItem,
    printReceivingSummaryReport,
    printReceivingDetailsReport,
    showErrorModal,
    closed,
    loadingRows,
    rowDetails,
    fetchSubRowDetails,
    subRowDetails,
    subLoadingRows,
    fetchRowDetails,
    reprintReceivingItem,
    getReceivingInvoiceDetails,
  } = props;

  const isReadOnly = isReadOnlyUser();

  const buttonOptions = [
    {
      name: "Summary Report",
      onClick: printReceivingSummaryReport,
      inProgress: false,
    },
    {
      name: "Details Report",
      onClick: printReceivingDetailsReport,
      inProgress: false,
    },
  ];

  const [inProgress, setInProgress] = useState(false);
  const [submitInProgress, setSubmitInProgress] = useState(false);
  const navigate = useNavigate();

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    if ("invoice_selected" in fieldValues) {
      temp.invoice_selected = null;
      if (fieldValues.invoice_selected.value === -1) {
        temp.invoice_selected = "This field is required.";
      }
    }

    if ("truck_selected" in fieldValues) {
      temp.truck_selected = null;
      if (fieldValues.truck_selected) {
        if (fieldValues.truck_selected.value === -1) {
          temp.truck_selected = "This field is required.";
        }
      } else {
        temp.truck_selected = "This field is required.";
      }
    }

    if ("supplier_selected" in fieldValues) {
      temp.supplier_selected = null;
      if (fieldValues.supplier_selected) {
        if (fieldValues.supplier_selected.value === -1) {
          temp.supplier_selected = "This field is required.";
        }
      } else {
        temp.supplier_selected = "This field is required.";
      }
    }

    if ("created_by" in fieldValues) {
      temp.created_by = null;
      if (fieldValues.created_by) {
        if (fieldValues.created_by.value === -1) {
          temp.created_by = "This field is required.";
        }
      } else {
        temp.created_by = "This field is required.";
      }
    }

    if ("invoice_number" in fieldValues) {
      temp.invoice_number = null;
      if (fieldValues.invoice_number === "") {
        temp.invoice_number = "This field is required.";
      }
    }

    if ("truck_question_1" in fieldValues) {
      temp.truck_question_1 = null;
      if (fieldValues.truck_question_1) {
        if (fieldValues.truck_question_1.value === -1) {
          temp.truck_question_1 = "This field is required.";
        }
      } else {
        temp.truck_question_1 = "This field is required.";
      }
    }

    if ("truck_question_2" in fieldValues) {
      temp.truck_question_2 = null;
      if (fieldValues.truck_question_2) {
        if (fieldValues.truck_question_2.value === -1) {
          temp.truck_question_2 = "This field is required.";
        }
      } else {
        temp.truck_question_2 = "This field is required.";
      }
    }

    if ("truck_question_3" in fieldValues) {
      temp.truck_question_3 = null;
      if (fieldValues.truck_question_3) {
        if (fieldValues.truck_question_3.value === -1) {
          temp.truck_question_3 = "This field is required.";
        }
      } else {
        temp.truck_question_3 = "This field is required.";
      }
    }

    if ("truck_question_4" in fieldValues) {
      temp.truck_question_4 = null;
      if (fieldValues.truck_question_4) {
        if (fieldValues.truck_question_4.value === -1) {
          temp.truck_question_4 = "This field is required.";
        }
      } else {
        temp.truck_question_4 = "This field is required.";
      }
    }

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === null);
  };

  const { values, setValues, errors, setErrors, handleInputChange } = useForm(
    initialFValues,
    true,
    validate,
  );

  useEffect(() => {
    if (receiving) {
      var truckSelected = [];
      if (receiving.truck_id) {
        truckSelected = truckOptions.find(
          (el) => el.value === receiving.truck_id,
        );
      }

      var supplierSelected = [];
      if (receiving.supplier_id) {
        supplierSelected = supplierOptions.find(
          (el) => el.value === receiving.supplier_id,
        );
      }

      var carrierSelected = [];
      if (receiving.carrier_id) {
        carrierSelected = carrierOptions.find(
          (el) => el.value === receiving.carrier_id,
        );
      }

      var createdBySelected = [];
      if (receiving.created_by) {
        createdBySelected = employeeOptions.find(
          (el) => el.value === receiving.created_by,
        );
      }

      var truckQuestion1 = [];
      if (receiving.truck_question_1) {
        truckQuestion1 = yesOrNoOptions.find(
          (el) => el.value === receiving.truck_question_1,
        );
      }

      var truckQuestion2 = [];
      if (receiving.truck_question_2) {
        truckQuestion2 = yesOrNoOptions.find(
          (el) => el.value === receiving.truck_question_2,
        );
      }

      var truckQuestion3 = [];
      if (receiving.truck_question_3) {
        truckQuestion3 = yesOrNoOptions.find(
          (el) => el.value === receiving.truck_question_3,
        );
      }

      var truckQuestion4 = [];
      if (receiving.truck_question_4) {
        truckQuestion4 = yesOrNoOptions.find(
          (el) => el.value === receiving.truck_question_4,
        );
      }

      var statusSelected = wipStatusOptions.find(
        (el) => el.value === receiving.status,
      );

      setValues({
        ...values,
        ...receiving,
        truck_selected: truckSelected,
        supplier_selected: supplierSelected,
        carrier_selected: carrierSelected,
        created_by: createdBySelected,
        statusSelected: statusSelected,
        truck_question_1: truckQuestion1,
        truck_question_2: truckQuestion2,
        truck_question_3: truckQuestion3,
        truck_question_4: truckQuestion4,
      });
      console.log("useeff");
    }
  }, [receiving]);

  const handleSubmit = () => {
    if (validate()) {
      if (isEdit) {
        updateReceivingInvoice(values);
      } else {
        createReceivingInvoice(values);
      }
    }
  };

  const deleteReceivingInvoiceClicked = async function () {
    setInProgress(true);
    if (isEdit) {
      const result = await onDeleteReceivingInvoice();
      setEmptyModelOpen({
        childComponent: null,
        open: false,
      });
      if (result.success) {
        if (isNewFlow) {
          setValues(initialFValues);
        } else {
          navigate("/receiving");
        }
      } else {
        showErrorModal(result.data.message);
      }
    } else {
      if (isNewFlow) {
        setValues(initialFValues);
        addSnackbar(
          new SnackbarData(
            generateUniqueNumber(),
            "Receiving restarted fresh",
            SnackbarType.Success,
          ),
        );
      }
    }
    setInProgress(false);
  };

  const onAskDeleteReceivingInvoice = () => {
    if (receiving.status === 1) {
      showErrorModal("Cannot delete closed receiving.");
    } else {
      setEmptyModelOpen({
        childComponent: (
          <DeleteConfirmationForm
            buttonMessage="Delete"
            confirmAction={deleteReceivingInvoiceClicked}
            message={`Are you sure you want to ${
              isNewFlow ? "restart" : "delete"
            } receiving?`}
            setOpen={setEmptyModelOpen}
            inProgress={inProgress}
          />
        ),
        open: true,
      });
    }
  };

  return (
    <div className="justify-between">
      <div className="hide-for-print">
        <div className="flex items-center justify-between flex-wrap sm:flex-nowrap">
          <div>
            <h3 className="text-lg leading-6 font-medium text-gray-900">
              {isEdit
                ? "V2_Editing Receiving Invoice " + values.invoice_number
                : "Add new receiving invoice"}
            </h3>
          </div>
          {isReadOnly ? null : (
            <div className="flex">
              {isEdit ? (
                <ButtonDropdown
                  items={buttonOptions}
                  mainOption="Save"
                  mainAction={handleSubmit}
                />
              ) : null}

              <button
                className="ml-2 rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-500"
                onClick={onAskDeleteReceivingInvoice}
              >
                {isNewFlow ? "Restart" : "Delete Receiving"}
              </button>
            </div>
          )}
        </div>
        <ReceivingInvoiceFields
          values={values}
          errors={errors}
          truckOptions={truckOptions}
          fetchPosForTruck={fetchPosForTruck}
          supplierOptions={supplierOptions}
          productOptions={productOptions}
          carrierOptions={carrierOptions}
          poOptions={poOptions}
          onFetchProductDetails={onFetchProductDetails}
          handleInputChange={handleInputChange}
          setEmptyModelOpen={setEmptyModelOpen}
          handleSubmit={handleSubmit}
          submitInProgress={submitInProgress}
          addItemToReceiving={addItemToReceiving}
          employeeOptions={employeeOptions}
          getWarehouses={getWarehouses}
          getWarehouseLocations={getWarehouseLocations}
          closed={closed}
          setValues={setValues}
        />

        {values.id > 0 ? (
          <ReceivingItemsTableComponent
            askReturnSelectedItems={askReturnSelectedItems}
            askDeleteReceivingItemById={askDeleteReceivingItemById}
            handleInputChange={handleInputChange}
            loading={false}
            values={values}
            setEmptyModelOpen={setEmptyModelOpen}
            updateReceivingItem={updateReceivingItem}
            openDeleteItemByBarcodePopup={openDeleteItemByBarcodePopup}
            selectedItems={selectedItems}
            setSelectedItems={setSelectedItems}
            onUpdateUnitCostForReceivingItem={onUpdateUnitCostForReceivingItem}
            onUpdateTotalCostForReceivingItem={
              onUpdateTotalCostForReceivingItem
            }
            closed={closed}
            loadingRows={loadingRows}
            rowDetails={rowDetails}
            fetchSubRowDetails={fetchSubRowDetails}
            subRowDetails={subRowDetails}
            subLoadingRows={subLoadingRows}
            fetchRowDetails={fetchRowDetails}
            reprintReceivingItem={reprintReceivingItem}
            onFetchPage={(page) => getReceivingInvoiceDetails(page)}
            rowsPerPage={values && values.items && values.items.per_page}
          />
        ) : null}
      </div>

      {/* <ReceivingBarcodeLabel barcodeDetails={barcodeDetails} /> */}
    </div>
  );
}
